module.exports = __webpack_public_path__ + "static/media/it_outdoor_hot_permacool.1bd33a3a.png";